import ApiClient from '@/api/client';

const path = require('path');

class HrefAPI extends ApiClient {

  constructor() {
    super();
  }

  /** CREATE */
  async createHrefFormat(data) {
    const response = await this.post(this.HREF_API_APTH, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  /** UPDATE */
  async updateHrefFormat(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async updateHrefResource(resourceData, data, async = false) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${resourceData.id}/`
    );
    const response = await this.patch(
      route,
      {
        href: resourceData.href,
        dataformat_id: resourceData.format.id
      }
    );
    const route2 = path.join(
      this.RESOURCE_API_PATH,
      `href/${resourceData.id}/?asynchrone=${async}`
    );
    const response2 = await this.patch(route2, data);
    if (response2.status === 200) {
      return response.data;
    }
    return false;
  }

  /** SCENARII */
  async getHrefResourceScenarios(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${id}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runHrefResourceScenario(id, scenarioId, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`
    );
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  /** SCHEDULERS */
  async setHrefScheduler(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${id}/scenario-execution-frequency/`
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async updateHrefScheduler(resourceId, data, scenarioId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${resourceId}/scenario-execution-frequency/${scenarioId}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async removeHrefScheduler(resourceId, scenarioId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `href/${resourceId}/scenario-execution-frequency/${scenarioId}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return true;
    }
    return false;
  }
};

const hrefAPI = new HrefAPI();
export default hrefAPI;